module.exports = "<div class=\"not-found\">\n  <p>Page Not Found</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/not-found/not-found.component.html
// module id = ./src/app/shared/components/not-found/not-found.component.html
// module chunks = main